import React from 'react'
import './manual.scss'

function Manual() {
    return (
        <div>
            
        </div>
    )
}

export default Manual